module.exports = __webpack_public_path__ + "img/figure_1_gr.557a983d.png";